<template>
    <div class="textarea textarea-counter">
        <textarea
            :class="classNames"
            v-model="textareaModel"
            :disabled="disabled"
            ref="textarea"
            :rows="rows"
            @input="onInput"
            @change="onChange"
        ></textarea>
        <div class="counter" v-if="showCounter">
            <span>{{ length }}</span>
            <span v-if="max">
                /{{ max }}
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TextareaCounter",

        data() {
            return {
                textareaModel: '',
            }
        },

        props: {
            classNames: {
                type: String,
                default: ''
            },

            value: {
                type: String,
                default: '',
            },

            max: {
                type: Number,
                default: null,
            },

            rows: {
                type: Number,
                default: 5,
            },

            disabled: {
                type: Boolean,
                default: false,
            },

            showCounter: {
              type: Boolean,
              default: true,
            }
        },

        mounted() {
            this.textareaModel = this.value;
        },

        watch: {
            value() {
                this.textareaModel = this.value;
                this.onInput();
            }
        },

        computed: {
            length() {
                return this.textareaModel.length;
            }
        },

        methods: {
            onChange() {
                this.$emit('change', this.$refs.textarea.value);
            },

            onInput() {
                this.$emit('input', this.$refs.textarea.value);
            },

            insert(text) {
                const textarea = this.$refs.textarea;
                // IE support
                if (document.selection) {
                    textarea.focus();
                    const sel = document.selection.createRange();
                    sel.text = text;
                }
                // MOZILLA and others
                else if (textarea.selectionStart || textarea.selectionStart == '0') {
                    var startPos = textarea.selectionStart;
                    var endPos = textarea.selectionEnd;
                    textarea.value = textarea.value.substring(0, startPos)
                        + text
                        + textarea.value.substring(endPos, textarea.value.length);
                } else {
                    textarea.value += text;
                }

                this.textareaModel = textarea.value;
                this.onInput();
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/TextareaCounter.vue